const ImportIcon = ({ width = 55, height = 55, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17_1139)">
        <path
          d="M8.94609 22.3015C8.60469 21.9655 8.59062 21.4054 8.91641 21.0517C8.99331 20.9678 9.08573 20.9003 9.18831 20.8532C9.29088 20.8061 9.40157 20.7804 9.51394 20.7775C9.62631 20.7746 9.73813 20.7946 9.84289 20.8363C9.94766 20.878 10.0433 20.9407 10.1242 21.0205L19.1352 29.929V0.885724C19.1352 0.396055 19.5219 0 20 0C20.4773 0 20.8641 0.396055 20.8641 0.885724V29.8834L29.5391 21.0309C29.875 20.6893 30.4164 20.6941 30.7469 21.0413C31.0773 21.3894 31.0727 21.9495 30.7367 22.2911L20.6805 32.5526C20.5999 32.6586 20.4967 32.7444 20.3787 32.8033C20.2608 32.8623 20.1312 32.8928 20 32.8926C19.7305 32.8926 19.4906 32.767 19.3312 32.5694L8.94609 22.3015ZM38.2703 31.1596C38.2703 30.6707 38.6578 30.2738 39.1352 30.2738C39.6125 30.2738 40 30.6707 40 31.1596V39.1143C40 39.6039 39.6125 40 39.1352 40H0.864844C0.386719 40 0 39.6039 0 39.1143V31.1596C0 30.6707 0.386719 30.2738 0.864844 30.2738C1.34219 30.2738 1.72969 30.6707 1.72969 31.1596V38.2294H38.2703V31.1596Z"
          fill="#21487D"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_1139">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ImportIcon
